<template>
  <div class="item-warp" @click="shopDetails(item)">
    <div class="shop-banner" :style="item.shopBanner ? `background-image:url(${item.shopBanner});` : ''" >
      <div class="shop-status" :class="onlineStatus(item.infoStatus).class">
        {{ onlineStatus(item.infoStatus).text }}
      </div>
    </div>
    <div class="shop-item-info">
      <div class="shop-item-left">
        <div>{{ item.pStoreType }}</div>
        <div class="shop-item-name">{{ item.shopName }}</div>
      </div>
      <div class="shop-item-nav">
        <img src="@/assets/imgs/shop/icon_shop_nav.png" alt="" />
        <span>{{ item.distance }}</span>
      </div>
    </div>
    <div class="shop-item-date-flex">
      <div class="shop-item-date">
        <img src="@/assets/imgs/shop/icon_shop_time.png" alt="" />
        <span>{{ item.shopTime || "-" }}</span>
      </div>
    </div>
    <div class="shop-item-gourp">
      <img src="@/assets/imgs/shop/icon_shop_address.png" alt="" />
      <span>{{ item.shopAddress1 }}</span>
    </div>
    <div class="shop-item-gourp">
      <img src="@/assets/imgs/shop/icon_shop_cost.png" alt="" />
      <span>
        {{ item.currencyName }} {{ $moneyFormat(item.pjifei) }} / {{ item.pjifeiDanwei }}
        {{ $priceUnit(item.priceUnit) }}
      </span>
    </div>
    <div class="shop-item-row">
      <div class="shop-item-device">
        <img src="@/assets/imgs/shop/icon_shop_cabinet.png" alt="">
        <div class="shop-item-device-info">
          <div class="shop-item-device-title">{{ item.freeNum }}</div>
          <div>{{ i18n.shop_power_banks }}</div>
        </div>
      </div>
      <div class="shop-item-device">
        <img src="@/assets/imgs/shop/icon_charge_available.png" alt="">
        <div class="shop-item-device-info">
          <div class="shop-item-device-title">{{ parseInt(item.batteryNum - item.freeNum) }}</div>
          <div>{{ i18n.shop_empty_slots }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    i18n() {
      return this.$t("shop")
    }
  },
  methods: {
    // 站点详情
    shopDetails(item) {
      this.$store.commit("shopInfo", item)
      this.$router.push(`/shop/details/${item.id}`)
    },
    // 获取状态
    onlineStatus(infoStatus) {
      return {
        text: this.$t(`map.${infoStatus}`),
        class: infoStatus === "在线" ? "online" : ""
      }
    }
  },
  created() {}
}
</script>

<style lang="less" scoped>
.item-warp {
  border-radius: 35px;
  margin-bottom: 28px;
  background: #fff;
  color: #000;
  padding: 28px 35px 26px;
  // border: 2px solid #d5d5d5;
  .shop-banner {
    position: relative;
    height: 172px;
    margin-bottom: 18px;
    background-color: #F8F6FC;
    border-radius: 18px;
    background-image: url('../../assets/imgs/banner-home.jpg');
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .shop-item-info {
    display: flex;
    align-items: center;
    .shop-item-left {
      flex: 1;
      width: 0;
      font-size: 22px;
      color: #A9ABAD;
      .shop-item-name {
        font-size: 36px;
        color: #000;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .shop-item-nav {
      padding: 13px 18px;
      font-size: 22px;
      color: #231F20;
      background: #EBEBEB;
      border-radius: 12px;
      display: flex;
      align-items: center;
      img {
        width: 26px;
        height: 26px;
        display: block;
        margin-right: 14px;
      }
    }
  }
  .shop-item-date-flex {
    display: flex;
  }
  .shop-item-date {
    padding: 4px 16px 4px 4px;
    background: #fff;
    border: 1px solid #AAAAAA;
    border-radius: 7px;
    font-size: 22px;
    color: #000102;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    img {
      width: 28px;
      height: 28px;
      display: block;
      margin-right: 4px;
    }
  }
  .shop-item-gourp {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: rgba(0, 1, 2, 0.5);
    margin-bottom: 10px;
    img {
      width: 32px;
      height: 32px;
      display: block;
      margin-right: 8px;
    }
  }
  .shop-item-row {
    display: flex;
    .shop-item-device {
      flex: 1;
      height: 77px;
      padding: 0 18px;
      display: flex;
      align-items: center;
      background: #F8F6FC;
      border-radius: 16px;
      .shop-item-device-info {
        flex: 1;
        font-size: 18px;
        color: rgba(64, 64, 65, 0.4);
        .shop-item-device-title {
          color: #404041;
          font-size: 26px;
        }
      }
      img {
        width: 49px;
        height: 49px;
        display: block;
        margin-right: 18px;
      }
    }
    .shop-item-device+.shop-item-device {
      margin-left: 48px;
    }
  }
  .item-gourp {
    display: flex;
    align-items: center;
    margin: 4px 0;
    font-size: 22px;
    img {
      width: 36px;
      margin-right: 8px;
    }
    .item-shopname {
      color: #000;
      font-size: 36px;
    }
  }

  .item-gourp-near {
    display: flex;
    align-items: center;
    margin-left: 24px;
    padding: 12px 20px;
    border-radius: 20px;
    background-color: #ebebeb;
    img {
      width: 26px;
    }
  }

  .item-gourp-row {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .shop-status {
    position: absolute;
    top: 0;
    left: 0;
    padding: 5px 32px;
    border-radius: 18px 0 18px 0;
    background-color: #C2C2C2;
    text-align: center;
    color: #fff;
    &.online {
      background-color: #FFCA0E;
    }
  }
}
</style>
